export const ROLE_CREATE_MODAL_EVENT = 'canvas-agent:user-role:create-modal';
export const ROLE_FILTER_EVENT = 'canvas-agent:user-role:filter';
export const ROLE_FOCUS_EVENT = 'canvas-agent:user-role:focus';
export const ROLE_EDIT_MODAL_EVENT = 'canvas-agent:user-role:edit-modal';
export const ROLE_DELETE_MODAL_EVENT = 'canvas-agent:user-role:delete-modal';
